import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ErrorData } from "../types";

type CodeEditorState = {
  panes: Array<any>;
  innerPanes: Array<any>;
  isErrorInSchemaEditor: boolean;
  isErrorInLayoutEditor: boolean;
  isErrorInOptionsEditor: boolean;
  errorsInSchemaEditor: ErrorData[];
  errorsInLayoutEditor: ErrorData[];
  errorsInOptionsEditor: ErrorData[];
};

const initialState: CodeEditorState = {
  isErrorInSchemaEditor: false,
  isErrorInLayoutEditor: false,
  isErrorInOptionsEditor: false,
  errorsInSchemaEditor: [],
  errorsInLayoutEditor: [],
  errorsInOptionsEditor: [],
  panes: [
    {
      size: "60%",
      collapsible: true,
    },
    {},
  ],
  innerPanes: [
    {},
    { size: "50%", collapsible: true },
    {
      size: "20%",
      collapsible: true,
      collapsed: true,
    },
  ],
};

export const codeEditorSlice = createSlice({
  name: "developer/edit/codeEditor",
  initialState,
  reducers: {
    setPanes(state, action: PayloadAction<Array<any>>) {
      state.panes = action.payload;
    },
    setInnerPanes(state, action: PayloadAction<Array<any>>) {
      state.innerPanes = action.payload;
    },
    setIsErrorInSchemaEditor(state, action: PayloadAction<boolean>) {
      state.isErrorInSchemaEditor = action.payload;
    },
    setIsErrorInLayoutEditor(state, action: PayloadAction<boolean>) {
      state.isErrorInLayoutEditor = action.payload;
    },
    setIsErrorInOptionsEditor(state, action: PayloadAction<boolean>) {
      state.isErrorInOptionsEditor = action.payload;
    },
    setErrorsInSchemaEditor(state, action: PayloadAction<ErrorData[]>) {
      state.errorsInSchemaEditor = action.payload;
    },
    setErrorsInLayoutEditor(state, action: PayloadAction<ErrorData[]>) {
      state.errorsInLayoutEditor = action.payload;
    },
    setErrorsInOptionsEditor(state, action: PayloadAction<ErrorData[]>) {
      state.errorsInOptionsEditor = action.payload;
    },
  },
});

export const {
  setPanes,
  setInnerPanes,
  setIsErrorInLayoutEditor,
  setIsErrorInOptionsEditor,
  setIsErrorInSchemaEditor,
  setErrorsInLayoutEditor,
  setErrorsInOptionsEditor,
  setErrorsInSchemaEditor,
} = codeEditorSlice.actions;
